module.exports = __webpack_public_path__ + "img/format-list-bulleted-inverted.d15280fd.svg";